module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', [_c('a', {
    attrs: {
      "id": "epi"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "epiv"
  }, [_vm._v("Every man’s work shall be made manifest: for the day shall declare it, because it shall be revealed by fire; and the fire shall try every man’s work of what sort it is.")]), _vm._v(" "), _c('div', {
    staticClass: "eps"
  }, [_vm._v("—I Corinthians 3:13")]), _vm._v(" "), _c('div', {
    staticClass: "epiv"
  }, [_c('div', [_c('br')]), _vm._v("You can’t eat for eight hours a day nor drink for eight hours a day nor make love for eight hours a day—all you can do for eight hours is work. Which is the reason why man makes himself and everybody else so miserable and unhappy.")]), _vm._v(" "), _c('div', {
    staticClass: "eps"
  }, [_vm._v("—William Faulkner")]), _vm._v(" "), _c('div', {
    staticClass: "epiv"
  }, [_c('div', [_c('br')]), _vm._v("The “work ethic” holds that labor is good in itself; that a man or woman becomes a better person by virtue of the act of working. America’s competitive spirit, the “work ethic” of this people, is alive and well on Labor Day, 1971.")]), _vm._v(" "), _c('div', {
    staticClass: "eps"
  }, [_vm._v("—Richard M. Nixon")]), _vm._v(" "), _c('div', {
    staticClass: "epiv"
  }, [_c('div', [_c('br')]), _vm._v("I like my job and am good at it, but it sure grinds me down sometimes, and the last thing I need to take home is a headache.")]), _vm._v(" "), _c('div', {
    staticClass: "eps"
  }, [_vm._v("—TV commercial for Anacin")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-56c7da85","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/stud_9781595587664_oeb_epi_r1.vue
// module id = 72
// module chunks = 0